let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hqZFk")).then(() => parcelRequire('1sHch'));